import { Component, Input } from '@angular/core';

const DEFAULT_ICON_SIZE = 20;

@Component({
  selector: 'rt-back-arrow-icon',
  standalone: true,
  templateUrl: './back-arrow-icon.component.html'
})
export class BackArrowIconComponent {
  @Input() size?: number = DEFAULT_ICON_SIZE;
  @Input() width?: number;
  @Input() height?: number;
}
